import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../configureStore';

const selectAdminReferralsState = (state: RootState) => state.adminReferrals;

const selectAdminReferralsOverview = createDraftSafeSelector(
  selectAdminReferralsState,
  (state) => state.overview,
);

const selectAdminReferralsLoading = createDraftSafeSelector(
  selectAdminReferralsState,
  (state) => state.loading,
);

export { selectAdminReferralsState, selectAdminReferralsOverview, selectAdminReferralsLoading };
